import { Range } from "immutable";
import React from "react";
import { PagingGoTo } from "./PagingGoTo";
import { PagingLink } from "./PagingLink";

interface PagingBarProps {
	pages: number;
	currentPage: number;
	onPageSelected: () => void;
}

export function PagingBar({
	pages,
	currentPage,
	onPageSelected,
}: PagingBarProps) {
	const padding = 1;
	const startPage = 0;
	const previousPage = Math.max(0, currentPage - 1);
	const lowestPageIndex = Math.max(0, currentPage - padding);
	const highestPageIndex = Math.min(currentPage + padding, pages - 1);
	const lastPage = Math.max(0, pages - 1);
	const nextPage = Math.min(lastPage, currentPage + 1);

	const lowGap = lowestPageIndex > 1 && <span className="inactive">...</span>;
	const highGap = highestPageIndex < pages - 2 && (
		<span className="inactive">...</span>
	);

	const links = Range(lowestPageIndex, highestPageIndex + 1)
		.map((p) => (
			<PagingLink
				key={p}
				page={p}
				selectedPage={currentPage}
				onPageSelected={onPageSelected}
			>
				{p + 1}
			</PagingLink>
		))
		.toArray();

	const firstPageLink = lowestPageIndex > 0 && (
		<PagingLink
			page={startPage}
			selectedPage={currentPage}
			onPageSelected={onPageSelected}
		>
			{startPage + 1}
		</PagingLink>
	);

	const lastPageLink = highestPageIndex < pages - 1 && (
		<PagingLink
			page={lastPage}
			selectedPage={currentPage}
			onPageSelected={onPageSelected}
		>
			{lastPage + 1}
		</PagingLink>
	);

	const prevPageLink = currentPage !== startPage && (
		<PagingLink
			page={previousPage}
			selectedPage={currentPage}
			onPageSelected={onPageSelected}
			navBtn
		>
			Go to previous page
		</PagingLink>
	);

	const nextPageLink = currentPage !== lastPage && (
		<PagingLink
			page={nextPage}
			selectedPage={currentPage}
			onPageSelected={onPageSelected}
			navBtn
		>
			Go to next page
		</PagingLink>
	);

	return (
		<nav className="paging-bar">
			<div className="paging-list">
				{prevPageLink}
				{firstPageLink}
				{lowGap}
				{links}
				{highGap}
				{lastPageLink}
				{nextPageLink}
			</div>

			<PagingGoTo currentPage={currentPage} onClick={onPageSelected} />
		</nav>
	);
}
